<template lang="html">
  <div class="">
    <!--<dashboard-component class="align-items-center" center>-->
      <navbar-component />
      <!--<card-component :col="{xs: 12}" mw="600px">-->
        <login-component/>
      <!--</card-component>-->
    <!--</dashboard-component>-->
    <!--<background-component bg="/static/bgs/2.jpg"/>-->
    <footer-component />
  </div>

</template>

<script>
import Card from '../../partial/card/Card.vue'
import Dashboard from '../../partial/dashboard/Dashboard.vue'
import Login from '../../partial/cards/login/Login.vue'
import Background from '../../partial/background/Background.vue'
import Footer from '../../partial/footer/Footer.vue'
import Navbar from '../../partial/navbar/Navbar.vue'

export default {
  data () {
    return {
      token: this.$route.query.token
    }
  },
  head: {
    title: function () {
      return {
        inner: 'Taxas melhores para seu empréstimo online'
      }
    }
  },
  components: {
    'card-component': Card,
    'dashboard-component': Dashboard,
    'background-component': Background,
    'login-component': Login,
    'navbar-component': Navbar,
    'footer-component': Footer
  },
  mounted () {
    if (this.token) {
      this.$auth.token(null, this.token)
      console.log('Auth: ' + this.$auth.check())
      this.$auth.login({
        params: {},
        success: function (res) {
          this.$auth.user(res.data)
          console.log('ok ' + this.$auth.token())
          console.log('Auth: ' + this.$auth.check('ROLE_USER'))
          console.log('Auth: ' + this.$auth.check('ROLE_ADMIN'))
          console.log('Auth: ' + this.$auth.check('ROLE_SUPER'))
        },
        error: function () {
          console.log('error')
        }
      })
    }
    // this.$ga.page('/#/login')
  },
  methods: {
  }
}

</script>

<style lang="scss">
  /*@import "../../../assets/scss/variaveis.scss";*/
  /*@import "../../../assets/scss/card.scss";*/
  /*.page-login {*/
    /*.dashboard {*/
      /*padding-top: 0;*/
    /*}*/
  /*}*/
  /*.page-enter-active, .page-leave-active {*/
    /*transition: opacity .3s*/
  /*}*/
  /*.page-enter, .page-leave-active {*/
    /*transition: opacity .3s*/
    /*!*opacity: 0*!*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/pages/login/Login.vue